/* SwimbaitSupply 2.0 storefront behaviours. Works on top of Dawn's pubsub, cart and product scripts. */
(function () {
  'use strict';
  var SSP = window.SSP || {};
  window.SSP = SSP;
  var hasPubSub = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

  /* ---------- helpers ---------- */
  function track(name, data) {
    if (SSP.events === false) return;
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ssp:track', { detail: { name: name, data: data } }));
  }
  SSP.track = track;

  function formatMoney(cents, format) {
    format = format || SSP.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function fmt(n, dec, ts, ds) {
      dec = dec === undefined ? 2 : dec; ts = ts || ','; ds = ds || '.';
      var num = (n / 100).toFixed(dec);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return fmt(cents);
    var value;
    switch (m[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(m[0], value);
  }
  SSP.formatMoney = formatMoney;

  function getCart() {
    return fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- free shipping ---------- */
  var fs = SSP.fs || { enabled: false };
  var lastDone = null;
  function lineExcluded(type) {
    type = (type || '').toLowerCase().trim();
    if (!type) return false;
    if ((fs.except || []).indexOf(type) > -1) return false;
    return (fs.exclude || []).some(function (k) { return k && type.indexOf(k) > -1; });
  }
  function fsState(cart) {
    var s = { show: !!fs.enabled && (fs.countries || []).indexOf(fs.country) > -1 };
    if (!s.show) return s;
    s.empty = !cart || cart.item_count === 0;
    s.excluded = false;
    (cart && cart.items || []).forEach(function (it) { if (lineExcluded(it.product_type)) s.excluded = true; });
    if (cart && cart.total_weight > fs.maxGrams) s.excluded = true;
    s.total = cart ? cart.total_price : 0;
    s.remaining = Math.max(0, fs.threshold - s.total);
    s.pct = Math.min(100, Math.round((s.total * 100) / fs.threshold));
    s.done = !s.empty && !s.excluded && s.remaining === 0;
    return s;
  }
  function awayText(remaining) {
    return (fs.msgAway || '[amount] away from free U.S. shipping').replace('[amount]', '<strong>' + formatMoney(remaining) + '</strong>');
  }
  function renderFs(el, s) {
    var kind = el.getAttribute('data-ssp-fs');
    var msg = el.querySelector('[data-ssp-fs-msg]');
    var fill = el.querySelector('[data-ssp-fs-fill]');
    var html = '';
    var hide = !s.show;
    var done = false;
    if (kind === 'bar') {
      if (!s.show) { hide = false; html = el.getAttribute('data-intl') || ''; }
      else if (s.empty || s.excluded) html = fs.msgIdle;
      else if (s.done) { html = fs.msgDone; done = true; }
      else html = awayText(s.remaining);
    } else if (kind === 'pdp') {
      var price = parseInt(el.getAttribute('data-price'), 10) || 0;
      var pState = el.getAttribute('data-product-state');
      if (!s.show) hide = true;
      else if (pState === 'excluded') html = el.getAttribute('data-msg-excluded');
      else if (pState === 'heavy') html = el.getAttribute('data-msg-heavy');
      else if (s.excluded) html = fs.msgIdle;
      else if (s.done) { html = fs.msgDone; done = true; }
      else if (price >= fs.threshold) { html = el.getAttribute('data-msg-free'); done = true; }
      else if (!s.empty && s.total + price >= fs.threshold) { html = el.getAttribute('data-msg-complete'); done = true; }
      else if (!s.empty) html = fs.msgIdle + ' &middot; ' + awayText(s.remaining);
      else html = fs.msgIdle;
    } else {
      if (!s.show || s.empty || s.excluded) hide = true;
      else if (s.done) { html = fs.msgDone; done = true; }
      else html = awayText(s.remaining);
    }
    if (msg) msg.innerHTML = html;
    if (fill) fill.style.width = (done ? 100 : s.pct || 0) + '%';
    el.classList.toggle('is-done', done);
    el.hidden = hide;
  }
  function updateFs(cart) {
    var s = fsState(cart);
    document.querySelectorAll('[data-ssp-fs]').forEach(function (el) {
      if (el.closest('cart-drawer') && el.getAttribute('data-ssp-fs') !== 'pdp') return; /* drawer re-renders server side */
      renderFs(el, s);
    });
    if (lastDone === false && s.done) track('ssp_free_shipping_unlocked', { total: s.total });
    lastDone = !!s.done;
  }
  SSP.updateFreeShipping = function () { return getCart().then(updateFs).catch(function () {}); };
  if (fs.enabled) {
    lastDone = !!(SSP.initialCart && fsState(SSP.initialCart).done);
    if (hasPubSub) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { SSP.updateFreeShipping(); });
  }
  SSP.renderPdpShipping = function (el, priceCents) {
    if (!el) return;
    el.setAttribute('data-price', priceCents);
    getCart().then(function (cart) { renderFs(el, fsState(cart)); }).catch(function () {});
  };

  /* ---------- header: sticky hide/show ---------- */
  var headerSection = document.querySelector('.section-header');
  if (headerSection) {
    var lastY = window.scrollY;
    var ticking = false;
    var onScroll = function () {
      var y = window.scrollY;
      var open = document.querySelector('.ssp-nav details[open], .ssp-header details-modal details[open], .ssp-drawer[open]');
      if (!open && y > lastY && y > 240) headerSection.classList.add('ssp-header--hidden');
      else if (y < lastY - 4 || y < 240) headerSection.classList.remove('ssp-header--hidden');
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    var setH = function () { document.documentElement.style.setProperty('--ssp-header-total', headerSection.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', setH);
  }

  /* ---------- desktop mega menu ---------- */
  var navItems = Array.prototype.slice.call(document.querySelectorAll('.ssp-nav__item details'));
  function closeAll(except) { navItems.forEach(function (d) { if (d !== except) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); } }); }
  navItems.forEach(function (d) {
    var li = d.parentElement, timer;
    var summary = d.querySelector('summary');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    li.addEventListener('mouseenter', function () { if (!fine.matches) return; clearTimeout(timer); timer = setTimeout(function () { closeAll(d); d.setAttribute('open', ''); summary.setAttribute('aria-expanded', 'true'); }, 90); });
    li.addEventListener('mouseleave', function () { if (!fine.matches) return; clearTimeout(timer); timer = setTimeout(function () { d.removeAttribute('open'); summary.setAttribute('aria-expanded', 'false'); }, 160); });
    d.addEventListener('toggle', function () { summary.setAttribute('aria-expanded', d.open ? 'true' : 'false'); if (d.open) { closeAll(d); track('ssp_menu_open', { menu: summary.textContent.trim() }); } });
    d.addEventListener('keyup', function (e) { if (e.key === 'Escape') { d.removeAttribute('open'); summary.focus(); } });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.ssp-nav')) closeAll(); });

  /* ---------- mobile drawer ---------- */
  var drawer = document.getElementById('SspMenu');
  if (drawer) {
    var openers = document.querySelectorAll('[aria-controls="SspMenu"]');
    var lastOpener;
    var openD = function (btn) {
      lastOpener = btn; drawer.setAttribute('open', ''); drawer.removeAttribute('aria-hidden');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      document.body.classList.add('overflow-hidden');
      var panel = drawer.querySelector('.ssp-drawer__panel');
      if (typeof trapFocus === 'function') trapFocus(panel, drawer.querySelector('[data-ssp-close]'));
      track('ssp_menu_open', { menu: 'mobile' });
    };
    var closeD = function () {
      drawer.removeAttribute('open'); drawer.setAttribute('aria-hidden', 'true');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(lastOpener);
    };
    openers.forEach(function (o) { o.addEventListener('click', function () { drawer.hasAttribute('open') ? closeD() : openD(o); }); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-ssp-close]') || e.target.classList.contains('ssp-drawer__overlay')) closeD(); });
    drawer.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeD(); });
  }

  /* ---------- rails ---------- */
  document.querySelectorAll('[data-ssp-rail]').forEach(function (rail) {
    var track = rail.querySelector('.ssp-rail__track');
    var prev = rail.querySelector('[data-ssp-prev]');
    var next = rail.querySelector('[data-ssp-next]');
    if (!track || !prev || !next) return;
    var upd = function () { prev.disabled = track.scrollLeft < 8; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8; };
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  });

  /* ---------- search synonyms ---------- */
  var rules = (SSP.synonyms || []).map(function (r) {
    var from = r[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return { re: new RegExp('(^|\\s)' + from + '(?=\\s|$)', 'gi'), to: r[1] };
  });
  function expand(q) {
    var out = ' ' + String(q || '').trim() + ' ';
    rules.forEach(function (r) { out = out.replace(r.re, function (m, pre) { return pre + r.to; }); });
    return out.replace(/\s+/g, ' ').trim();
  }
  SSP.expandQuery = expand;
  function patchPredictive() {
    var PS = customElements.get('predictive-search');
    if (!PS || PS.prototype.__ssp) return;
    var orig = PS.prototype.getSearchResults;
    PS.prototype.getSearchResults = function (term) { return orig.call(this, expand(term)); };
    PS.prototype.__ssp = true;
  }
  patchPredictive();
  document.addEventListener('DOMContentLoaded', patchPredictive);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.getAttribute('role') !== 'search' && !/\/search(\?|$)/.test(form.getAttribute('action') || '')) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    var ex = expand(input.value);
    track('ssp_search_submit', { q: input.value.trim(), expanded: ex });
    if (ex.toLowerCase() !== input.value.trim().toLowerCase()) input.value = ex;
  }, true);
  if (document.body.getAttribute('data-template') === 'search') {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q') || '';
    var count = parseInt(document.body.getAttribute('data-search-count') || '-1', 10);
    var ex = expand(q);
    if (q && count === 0 && !params.get('ssp_from') && ex.toLowerCase() !== q.toLowerCase()) {
      params.set('q', ex); params.set('ssp_from', q);
      window.location.replace(window.location.pathname + '?' + params.toString());
    } else if (params.get('ssp_from')) {
      var note = document.querySelector('[data-ssp-search-note]');
      if (note) { note.textContent = (note.getAttribute('data-text') || 'Showing results for [q]').replace('[q]', '“' + q + '”'); note.hidden = false; }
    }
  }

  /* ---------- product page: variant sync + sticky buy bar ---------- */
  function mainInfo() { return document.querySelector('product-info[id^="MainProduct-"]'); }
  if (hasPubSub) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      var d = evt.data || {};
      var info = mainInfo();
      if (!info || info.dataset.section !== d.sectionId) return;
      info.querySelectorAll('[data-ssp-sync]').forEach(function (el) {
        var src = d.html && d.html.getElementById(el.id);
        if (src) el.innerHTML = src.innerHTML;
      });
      var ship = info.querySelector('[data-ssp-fs="pdp"]');
      if (ship && d.variant) SSP.renderPdpShipping(ship, d.variant.price);
      applyPreorderLabel(info);
      updateSticky(d.variant);
    });
  }
  function applyPreorderLabel(scope) {
    (scope || document).querySelectorAll('product-form[data-ssp-preorder] [type="submit"]:not([disabled]) > span').forEach(function (s) {
      s.textContent = s.closest('product-form').getAttribute('data-ssp-preorder');
    });
  }
  applyPreorderLabel();

  var sticky = document.querySelector('[data-ssp-sticky]');
  function mainSubmit() { var i = mainInfo(); return i && i.querySelector('product-form [type="submit"][name="add"]'); }
  function updateSticky(variant) {
    if (!sticky) return;
    var btn = sticky.querySelector('[data-ssp-sticky-add]');
    var priceEl = sticky.querySelector('[data-ssp-sticky-price]');
    var varEl = sticky.querySelector('[data-ssp-sticky-variant]');
    var main = mainSubmit();
    if (variant) {
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (varEl) varEl.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    }
    if (btn && main) {
      btn.disabled = main.disabled;
      var label = main.querySelector('span');
      btn.querySelector('span').textContent = label ? label.textContent.trim() : btn.textContent;
    }
  }
  /* Keep floating app buttons (chat, rewards, wishlist, forms teaser) above the sticky bar. */
  function liftEmbeds(on) {
    var h = on && sticky ? sticky.offsetHeight : 0;
    document.documentElement.style.setProperty('--ssp-sticky-h', h + 'px');
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root) return;
      var st = root.getElementById('ssp-lift');
      if (!st) { st = document.createElement('style'); st.id = 'ssp-lift'; root.appendChild(st); }
      st.textContent = '.appEmbed{transition:translate .3s ease;translate:0 ' + (-h) + 'px}';
    });
  }
  if (sticky) {
    var target = mainSubmit();
    if (target && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          sticky.inert = !show;
          document.body.classList.toggle('ssp-sticky-on', show);
          liftEmbeds(show);
        });
      }, { threshold: 0 });
      io.observe(target);
    }
    sticky.addEventListener('click', function (e) {
      var add = e.target.closest('[data-ssp-sticky-add]');
      if (add) {
        var main = mainSubmit();
        if (main && !main.disabled) { track('ssp_sticky_atc', {}); main.click(); }
      }
      var opts = e.target.closest('[data-ssp-sticky-options]');
      if (opts) { var vs = document.querySelector('product-info[id^="MainProduct-"] variant-selects'); if (vs) { vs.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
    });
    updateSticky();
  }

  /* ---------- clamp toggles ---------- */
  document.querySelectorAll('[data-ssp-clamp-toggle]').forEach(function (btn) {
    var tgt = document.getElementById(btn.getAttribute('aria-controls'));
    if (!tgt) return;
    if (tgt.scrollHeight <= tgt.clientHeight + 4) { btn.hidden = true; return; }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = tgt.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
  });

  /* ---------- analytics hooks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el = t.closest('[data-ssp-track]');
    if (el) track(el.getAttribute('data-ssp-track'), { label: (el.getAttribute('data-ssp-label') || el.textContent || '').trim().slice(0, 80), href: el.getAttribute('href') || '' });
    var reco = t.closest('[data-ssp-reco] a, a[data-ssp-reco]');
    if (reco) { var box = reco.closest('[data-ssp-reco]'); track('ssp_reco_click', { source: box ? box.getAttribute('data-ssp-reco') : '', href: reco.getAttribute('href') }); }
    if (t.closest('.shopify-payment-button')) { var pi = t.closest('product-info'); track('ssp_buy_now_click', { product: pi ? pi.getAttribute('data-product-id') : '' }); }
    if (t.closest('.ssp-express, .cart__dynamic-checkout-buttons')) track('ssp_express_click', {});
    var ps = t.closest('#predictive-search-results a, .predictive-search a');
    if (ps) { var inp = document.querySelector('predictive-search input[name="q"]'); track('ssp_search_click', { q: inp ? inp.value : '', href: ps.getAttribute('href') }); }
    if (t.closest('.ssp-card__quick modal-opener, .ssp-card__quick [data-product-url]')) track('ssp_quick_view', { href: (t.closest('[data-product-url]') || {}).getAttribute ? t.closest('[data-product-url]').getAttribute('data-product-url') : '' });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.closest && f.closest('.ssp-card__quick, .ssp-upsell')) track(f.closest('.ssp-upsell') ? 'ssp_reco_add' : 'ssp_quick_add', { variant: (f.querySelector('[name="id"]') || {}).value || '' });
    if (f.hasAttribute && f.hasAttribute('data-ssp-signup')) track('ssp_signup', { location: f.getAttribute('data-ssp-signup') });
  }, true);
  document.addEventListener('change', function (e) {
    var f = e.target.closest('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, .facets__form');
    if (f) track('ssp_filter', { name: e.target.name, value: e.target.value });
  });
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && 'MutationObserver' in window) {
    var wasActive = false;
    new MutationObserver(function () {
      var active = cartDrawer.classList.contains('active');
      if (active && !wasActive) track('ssp_cart_open', {});
      wasActive = active;
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
})();